import { graphql } from '@/gql/storefront';

export const productFragment = graphql(`
    fragment Product on Product {
        id
        handle
        availableForSale
        title
        description
        descriptionHtml
        priceRange {
            maxVariantPrice {
                amount
                currencyCode
            }
            minVariantPrice {
                amount
                currencyCode
            }
        }
        collections(first: 10) {
            nodes {
                handle
                title
                image {
                    ...Image
                }
            }
        }
        selectedOrFirstAvailableVariant {
            sku
        }
        shortDescription: metafield(
            namespace: "product"
            key: "short_description"
        ) {
            value
        }
        benefits: metafield(namespace: "product", key: "benefits") {
            value
        }
        details: metafield(namespace: "product", key: "details") {
            value
        }

        variants(first: 250) {
            edges {
                node {
                    id
                    title
                    availableForSale
                    selectedOptions {
                        name
                        value
                    }
                    price {
                        amount
                        currencyCode
                    }
                }
            }
        }
        featuredImage {
            ...Image
        }
        images(first: 20) {
            edges {
                node {
                    ...Image
                }
            }
        }
        media(first: 20) {
            edges {
                node {
                    ...Media
                }
            }
        }
        tags
        updatedAt
        seo {
            ...Seo
        }
        sellingPlanGroups(first: 10) {
            nodes {
                sellingPlans(first: 10) {
                    edges {
                        node {
                            id
                            name
                            description
                            recurringDeliveries
                            priceAdjustments {
                                adjustmentValue {
                                    ... on SellingPlanFixedPriceAdjustment {
                                        __typename
                                        price {
                                            amount
                                            currencyCode
                                        }
                                    }
                                    ... on SellingPlanPercentagePriceAdjustment {
                                        __typename
                                        adjustmentPercentage
                                    }
                                    ... on SellingPlanFixedAmountPriceAdjustment {
                                        __typename
                                        adjustmentAmount {
                                            amount
                                            currencyCode
                                        }
                                    }
                                }
                            }
                            deliveryPolicy {
                                ... on SellingPlanRecurringDeliveryPolicy {
                                    __typename
                                    interval
                                    intervalCount
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`);
